import { Grid, Menu, ListItemText, ListItemIcon, Typography, Box, FormControlLabel, Switch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowDropDown, PlaylistAddCheck } from '@material-ui/icons';
import { Button, ConfirmationMenuItem, ConfirmDialog, SelectField, Toolbar } from '@roc/ui';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';
import { OrderTaxCertificateModal } from './orderTaxCertificateModal';
import { useTaxCertificateStore } from '../hooks/useTaxCertificateStore';
import { TaxTabs } from '../types/types';
import { UploadPaymentZipModal } from './uploadPaymentZipModal';
import { UploadRefundsFileModal } from './uploadRefundsFileModal';
import { PAYMENT_APPROVAL_FILTER } from '../utils/constants';
import { ToolbarInfoItem } from '@roc/feature-special-servicing';

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: 'flex',
    gap: '10px'
  },
  selectorFilterContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  selectorFilter: {
    minWidth: '200px'
  },
  containerBox: {
    display: 'flex',
  },
  infoItemsBox: {
    marginRight: '40px',
    marginLeft: '25px',
    display: 'flex',
    alignItems: 'center',
    gap: '30px'
  },
}));


export const TaxCertificateToolbar = observer(() => {
  const [showOrderCertificateModal, setShowOrderCertificateModal] = useState(false)
  const { taxCertificateStore } = useTaxCertificateStore();


  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Toolbar>
            <Button
              variant="contained"
              color="primary"
              testId="create-order-bpo"
              onClick={() => {
                setShowOrderCertificateModal(true);
              }}
              size="small"
            >
              Order Certificate
            </Button>
          </Toolbar>
        </Grid>
      </Grid>
      <OrderTaxCertificateModal
        showOrderCertificateModal={showOrderCertificateModal}
        closeOrderModal={() => setShowOrderCertificateModal(false)}
      />
    </>


  );
});


export const RedemptionToolbar = observer(() => {
  const classes = useStyles();
  const { taxCertificateStore } = useTaxCertificateStore();
  const { loanIds, showSelectedRecords } = taxCertificateStore;
  const anchorRef = useRef(null);
  const [showBulkActionsMenu, setShowBulkActionsMenu] = useState(false);

  const closeMenu = () => {
    setShowBulkActionsMenu(false);
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Toolbar>
            <Box className={classes.containerBox}>
              <Box className={classes.infoItemsBox}>
                <ToolbarInfoItem
                  value={loanIds.length}
                  label={'Count'}
                />
              </Box>
              <Box style={{ textAlign: 'center', marginRight: '25px' }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={showSelectedRecords}
                      onChange={() => {
                        taxCertificateStore.setShowSelectedRecords(!showSelectedRecords);
                        taxCertificateStore.taxCertificateGridStore.resetAndFetchGridData();
                      }}
                      color="primary"
                    />
                  }
                  label="Show Selected"
                />
              </Box>
              <Box style={{ textAlign: 'center' }}>
                <div ref={anchorRef} style={{ display: 'inline-block' }}>
                  <Button
                    onClick={() => { setShowBulkActionsMenu(true) }}
                    testId="open_menu"
                    variant="contained"
                    size="small"
                    color="primary"
                    disabled={loanIds.length === 0}
                  >
                    Bulk Actions <ArrowDropDown style={{ marginRight: '-6px' }} />
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorRef.current}
                    open={showBulkActionsMenu}
                    onClose={closeMenu}
                    keepMounted={true}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    getContentAnchorEl={null}
                  >
                    <ConfirmationMenuItem
                      testId={`create-redemption-request`}
                      onClick={async () => {
                        taxCertificateStore.createRedemptionRequest();
                      }}
                      confirmDialogProps={{
                        body: `Are you sure you want to send a redemption request?`,
                      }}
                    >
                      <ListItemIcon>
                        <PlaylistAddCheck fontSize="small" />
                      </ListItemIcon>
                      <ListItemText onClick={closeMenu}>Create Redemption Request</ListItemText>
                    </ConfirmationMenuItem>
                  </Menu>
                </div>
              </Box>
            </Box>
          </Toolbar>
        </Grid>
      </Grid>
    </>
  );
});


export const PaymentApprovalToolbar = observer(() => {
  const classes = useStyles();
  const { taxCertificateStore } = useTaxCertificateStore();
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openUploadRefundsModal, setOpenUploadRefundsModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const sendPaymentApproval = () => {
    taxCertificateStore.sendAllPaymentApproval();
    setOpenConfirmModal(false);
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Toolbar
            left={
              <Grid className={classes.selectorFilterContainer}>
                <Typography style={{ paddingRight: '16px' }}>Filter: </Typography>
                <SelectField
                  className={classes.selectorFilter}
                  testId={'typeOfFee'}
                  fullWidth
                  variant="outlined"
                  options={PAYMENT_APPROVAL_FILTER}
                  value={taxCertificateStore.paymentAprovalSelectedFilter}
                  onChange={value => {
                    taxCertificateStore.setPaymentAprovalSelectedFilter(value);
                  }}
                  required={true}
                />
              </Grid>

            }>
            <Box className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                testId="create-order-bpo"
                onClick={() => {
                  setOpenUploadModal(true);
                }}
                size="small"
              >
                Upload Payment Files
              </Button>
              <Button
                variant="contained"
                color="primary"
                testId="upload-refunds"
                onClick={() => {
                  setOpenUploadRefundsModal(true);
                }}
                size="small"
              >
                Upload Refunds
              </Button>
              <Button
                variant="contained"
                color="primary"
                testId="create-order-bpo"
                onClick={() => taxCertificateStore.exportPropertyTaxReport()}
                size="small"
              >
                Download Tax Report
              </Button>
              <Button
                variant="contained"
                color="primary"
                testId="create-order-bpo"
                onClick={() => setOpenConfirmModal(true)}
                size="small"
              >
                Send Payment Approval
              </Button>
            </Box>

          </Toolbar>
        </Grid>
      </Grid>
      <UploadPaymentZipModal open={openUploadModal} onClose={() => setOpenUploadModal(false)} />
      <UploadRefundsFileModal open={openUploadRefundsModal} onClose={() => setOpenUploadRefundsModal(false)} />

      <ConfirmDialog
        open={openConfirmModal}
        body={<span>Are you sure you want to send the payment approval request?</span>}
        confirmButtonText={'Confirm'}
        handleCancel={() => setOpenConfirmModal(false)}
        handleClose={() => setOpenConfirmModal(false)}
        handleConfirm={sendPaymentApproval}
      />
    </>

  );
});

export const getTaxToolbar = (tab: TaxTabs): React.ReactNode => {

  switch (tab) {
    case TaxTabs.TAX_CERTIFICATE:
      return <TaxCertificateToolbar />
    case TaxTabs.REDEMPTION_REQUEST:
      return <RedemptionToolbar />
    case TaxTabs.PAYMENT_APPROVAL:
      return <PaymentApprovalToolbar />
    default:
      return <></>;
  }

}
